export const messages = {
  en: {
    feeComboManage: {
      search: {
        title: 'Search Fee Combo',
        comboName: 'Enter fee combo name',
        reset: 'Reset'
      },
      list: {
        title: 'Fee Combo List'
      },
      table: {
        comboName: 'Combo Name',
        remark: 'Remark',
        createTime: 'Create Time',
        member: 'Members'
      },
      member: {
        title: 'Combo Members',
        add: 'Add Member',
        feeType: 'Fee Type',
        feeName: 'Fee Item',
        feeFlag: 'Fee Flag',
        billType: 'Billing Method',
        paymentCycle: 'Payment Cycle',
        formula: 'Formula',
        price: 'Unit Price',
        fetchError: 'Failed to load combo members'
      },
      add: {
        title: 'Add Fee Combo',
        comboName: 'Combo Name',
        comboNamePlaceholder: 'Enter combo name',
        feeItems: 'Fee Items',
        feeItemsPlaceholder: 'Select fee items',
        remark: 'Remark',
        remarkPlaceholder: 'Enter remark',
        error: 'Failed to add fee combo'
      },
      edit: {
        title: 'Edit Fee Combo',
        comboName: 'Combo Name',
        comboNamePlaceholder: 'Enter combo name',
        remark: 'Remark',
        remarkPlaceholder: 'Enter remark',
        error: 'Failed to edit fee combo'
      },
      delete: {
        title: 'Delete Fee Combo',
        confirmMessage: 'Confirm deleting this fee combo?',
        cancel: 'Cancel',
        confirm: 'Confirm',
        error: 'Failed to delete fee combo'
      },
      validate: {
        comboNameRequired: 'Combo name is required',
        comboNameMaxLength: 'Combo name cannot exceed 30 characters',
        feeItemsRequired: 'Fee items are required',
        comboIdRequired: 'Combo ID is required'
      },
      fetchConfigError: 'Failed to load fee items',
      fetchError: 'Failed to load fee combos'
    },
    feeComboMemberManage: {
      feeType: 'Fee Type',
      selectFeeType: 'Select fee type',
      feeItem: 'Fee Item',
      selectFeeItem: 'Select fee item',
      feeTypeRequired: 'Fee type is required',
      feeItemRequired: 'Fee item is required',
      fetchDictError: 'Failed to load fee type dictionary',
      fetchFeeConfigError: 'Failed to load fee items',
      addFailed: 'Failed to add combo member',
      confirmDelete: 'Confirm deleting this combo member?',
      deleteFailed: 'Failed to delete combo member'
    }
  },
  zh: {
    feeComboManage: {
      search: {
        title: '查询费用套餐',
        comboName: '请输入费用套餐名称',
        reset: '重置'
      },
      list: {
        title: '费用套餐列表'
      },
      table: {
        comboName: '套餐名称',
        remark: '说明',
        createTime: '创建时间',
        member: '成员'
      },
      member: {
        title: '套餐成员',
        add: '添加成员',
        feeType: '费用类型',
        feeName: '费用项目',
        feeFlag: '费用标识',
        billType: '计费方式',
        paymentCycle: '缴费周期',
        formula: '公式',
        price: '单价',
        fetchError: '查询套餐成员失败'
      },
      add: {
        title: '添加费用套餐',
        comboName: '套餐名称',
        comboNamePlaceholder: '请输入套餐名称',
        feeItems: '费用项目',
        feeItemsPlaceholder: '请选择费用项目',
        remark: '说明',
        remarkPlaceholder: '请输入说明',
        error: '添加费用套餐失败'
      },
      edit: {
        title: '修改费用套餐',
        comboName: '套餐名称',
        comboNamePlaceholder: '请输入套餐名称',
        remark: '说明',
        remarkPlaceholder: '请输入说明',
        error: '修改费用套餐失败'
      },
      delete: {
        title: '删除费用套餐',
        confirmMessage: '确认删除该费用套餐？',
        cancel: '取消',
        confirm: '确认',
        error: '删除费用套餐失败'
      },
      validate: {
        comboNameRequired: '套餐名称不能为空',
        comboNameMaxLength: '套餐名称不能超过 30 个字符',
        feeItemsRequired: '费用项目不能为空',
        comboIdRequired: '套餐编号不能为空'
      },
      fetchConfigError: '查询费用项目失败',
      fetchError: '查询费用套餐失败'
    },
    feeComboMemberManage: {
      feeType: '费用类型',
      selectFeeType: '请选择费用类型',
      feeItem: '费用项目',
      selectFeeItem: '请选择费用项目',
      feeTypeRequired: '费用类型不能为空',
      feeItemRequired: '费用项目不能为空',
      fetchDictError: '查询费用类型字典失败',
      fetchFeeConfigError: '查询费用项目失败',
      addFailed: '添加套餐成员失败',
      confirmDelete: '确认删除该套餐成员？',
      deleteFailed: '删除套餐成员失败'
    }
  },
  'zh-TW': {
    feeComboManage: {
      search: {
        title: '查詢費用套餐',
        comboName: '請輸入費用套餐名稱',
        reset: '重置'
      },
      list: {
        title: '費用套餐列表'
      },
      table: {
        comboName: '套餐名稱',
        remark: '說明',
        createTime: '創建時間',
        member: '成員'
      },
      member: {
        title: '套餐成員',
        add: '添加成員',
        feeType: '費用類型',
        feeName: '費用項目',
        feeFlag: '費用標識',
        billType: '計費方式',
        paymentCycle: '繳費週期',
        formula: '公式',
        price: '單價',
        fetchError: '查詢套餐成員失敗'
      },
      add: {
        title: '添加費用套餐',
        comboName: '套餐名稱',
        comboNamePlaceholder: '請輸入套餐名稱',
        feeItems: '費用項目',
        feeItemsPlaceholder: '請選擇費用項目',
        remark: '說明',
        remarkPlaceholder: '請輸入說明',
        error: '添加費用套餐失敗'
      },
      edit: {
        title: '修改費用套餐',
        comboName: '套餐名稱',
        comboNamePlaceholder: '請輸入套餐名稱',
        remark: '說明',
        remarkPlaceholder: '請輸入說明',
        error: '修改費用套餐失敗'
      },
      delete: {
        title: '刪除費用套餐',
        confirmMessage: '確認刪除該費用套餐？',
        cancel: '取消',
        confirm: '確認',
        error: '刪除費用套餐失敗'
      },
      validate: {
        comboNameRequired: '套餐名稱不能為空',
        comboNameMaxLength: '套餐名稱不能超過 30 個字符',
        feeItemsRequired: '費用項目不能為空',
        comboIdRequired: '套餐編號不能為空'
      },
      fetchConfigError: '查詢費用項目失敗',
      fetchError: '查詢費用套餐失敗'
    },
    feeComboMemberManage: {
      feeType: '費用類型',
      selectFeeType: '請選擇費用類型',
      feeItem: '費用項目',
      selectFeeItem: '請選擇費用項目',
      feeTypeRequired: '費用類型不能為空',
      feeItemRequired: '費用項目不能為空',
      fetchDictError: '查詢費用類型字典失敗',
      fetchFeeConfigError: '查詢費用項目失敗',
      addFailed: '添加套餐成員失敗',
      confirmDelete: '確認刪除該套餐成員？',
      deleteFailed: '刪除套餐成員失敗'
    }
  }
}
